import { Component, ErrorHandler, Inject, Input, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core'

import { TunnistautuminenService } from 'app/_angular/service/tunnistautuminen.service'

import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'

import { ActionAfterAuthenticationLemonator, AloitaTunnistautuminenJaAnnaUrlResponse, InGroupeAuthMethod } from '@lemon/core-firebase/model/tunnistaminen'
import { TuettuKieli } from '@lemon/core/model/common'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'

@Component({
  selector: '[tunnistautuminen-nets-pankit]',
  templateUrl: './pankit.component.html',
  styleUrls: ['./pankit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TunnistautuminenNetsPankitComponent implements OnInit {
  @Input() actionAfterSuccess: ActionAfterAuthenticationLemonator
  @Input() kieli: TuettuKieli

  constructor(
    @Inject(DOCUMENT) protected _document: Document,
    protected _ladataanService: LadataanService,
    protected _errorHandler: ErrorHandler,
    protected _tunnistautuminenService: TunnistautuminenService,
    protected _firebaseLemonator: FirebaseLemonator,
  ) {}

  ngOnInit() {}

  protected async _aloitaTunnistautuminenJaAnnaUrl(_authMethod: InGroupeAuthMethod): Promise<AloitaTunnistautuminenJaAnnaUrlResponse> {
    throw new Error('Default method not implemented, override this in subclass!')
  }

  private async _tunnistaudu(authMethod: InGroupeAuthMethod): Promise<void> {
    this._ladataanService.aloitaLataaminen()
    try {
      const response = await this._aloitaTunnistautuminenJaAnnaUrl(authMethod)

      try {
        await this._tunnistautuminenService.startClientSideAuthenticationSession(this.actionAfterSuccess, response.avain, response.state)
      } catch (e) {
        this._errorHandler.handleError(new Error('Tunnistautumisen aloittaminen epäonnistui - session storageen kirjoittaminen epäonnistui!'))
        throw e
      }

      this._document.location.href = response.url
    } catch (e) {
      this._errorHandler.handleError(e)
      this._ladataanService.lopetaLataaminen()
    }
  }

  async tunnistauduMobiilivarmenne() {
    await this._tunnistaudu('fi_mobiilivarmenne')
  }

  async tunnistauduOp() {
    await this._tunnistaudu('opbank')
  }

  async tunnistauduNordea() {
    await this._tunnistaudu('nordea')
  }

  async tunnistauduDanske() {
    await this._tunnistaudu('danske')
  }

  async tunnistauduHandels() {
    await this._tunnistaudu('handelsbanken')
  }

  async tunnistauduAlands() {
    await this._tunnistaudu('aland')
  }

  async tunnistauduS() {
    await this._tunnistaudu('sbank')
  }

  async tunnistauduAktia() {
    await this._tunnistaudu('aktia')
  }

  async tunnistauduPop() {
    await this._tunnistaudu('popbank')
  }

  async tunnistauduSaasto() {
    await this._tunnistaudu('savingsbank')
  }

  async tunnistauduOmaSaasto() {
    await this._tunnistaudu('omasp')
  }
}
